import { createAction } from '@reduxjs/toolkit';

import { TicketSelectOption } from '@/types/tickets';

export const eventPaymentsKey = 'eventPayments';

export interface EventPaymentsState {
    readonly selectedTickets: TicketSelectOption[];
}

export enum EventPaymentActionTypes {
    increaseTicketCounter = 'eventPayments/increaseTicketCounter',
    decreaseTicketCounter = 'eventPayments/decreaseTicketCounter',
    selectSeat = 'eventPayments/selectSeat',
    selectEventPaymentTickets = 'eventPayments/selectTicket',
    resetSelectedTickets = 'eventPayments/resetSelectedTickets',
}

export const increaseTicketCounter = createAction<TicketSelectOption>(EventPaymentActionTypes.increaseTicketCounter);
export const decreaseTicketCounter = createAction<TicketSelectOption>(EventPaymentActionTypes.decreaseTicketCounter);
export const selectSeat = createAction<{ ticket: TicketSelectOption }>(EventPaymentActionTypes.selectSeat);
export const selectTicket = createAction<{ ticket: TicketSelectOption; action: 'increase' | 'decrease' }>(
    EventPaymentActionTypes.selectEventPaymentTickets,
);
export const resetSelectedTickets = createAction(EventPaymentActionTypes.resetSelectedTickets);

export type EventPaymentActions =
    | ReturnType<typeof increaseTicketCounter>
    | ReturnType<typeof decreaseTicketCounter>
    | ReturnType<typeof selectSeat>
    | ReturnType<typeof selectTicket>
    | ReturnType<typeof resetSelectedTickets>;
